import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import { IFilters } from "@/interfaces/Fetch";
import {
  useDeletePersonNoteMutation,
  useGetPersonNotesQuery,
} from "@/services/people/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { FC, useEffect, useState } from "react";
import { ToastContentProps, toast } from "react-toastify";
import NotesCard from "../NotesCard";

const PersonNotesCard: FC<PaginateCardProps & { id: string }> = ({
  id,
  onGetTotal,
}) => {
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isError, error } = useGetPersonNotesQuery([
    id,
    filters,
  ]);
  const [deletePersonNoteAsync] = useDeletePersonNoteMutation();

  const onDeleteNote = (noteId: string) => {
    toast.promise(deletePersonNoteAsync([id, noteId]).unwrap(), {
      pending: "Suppression de la note en cours...",
      success: {
        render() {
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              La note à bien été supprimée 🤩
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "Les champs que vous avez remplis semblent être incorrects.";
          }

          return "Une erreur est survenue";
        },
      },
    });
  };

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader absolute />;
  } else if (isError) {
    return <ErrorComponent error={error} absolute returnButton />;
  }

  return (
    <NotesCard
      data={data?.data}
      meta={data?.meta}
      filters={filters}
      setFilters={setFilters}
      onRemove={onDeleteNote}
    />
  );
};

export default PersonNotesCard;
